export enum ProductCTAConstants {
  OUT_OF_STOCK = 'out_of_stock',
  BACK_IN_STOCK = 'back_in_stock_after',
  ADD_TO_CART = 'add_to_cart',
  ADD_TO_BAG = 'add_to_bag',
  SHOP_SIMILAR = 'shop_similar',
  JOIN_WAITLIST = 'join_waitlist',
  WAITLISTED = 'waitlisted',
  ITEM_NO_LONGER_AVAILABLE = 'item_no_longer_available',
}
